<div class="d-flex">
    <div>
        <app-superadminsidenav></app-superadminsidenav>
    </div>
    <div style="
    height: 100vh;
    overflow: scroll;
    width: 100%;
    background-color: rgba(250, 250, 250, 1);
  ">
        <div class="container">
            <div class="settingHead">
                <div class="settingBtn" [ngClass]="{'bgSelectClass': restoSelectedCondition}"
                    (click)="restoSelectFunc()">
                    Restaurants
                </div>
                <div class="settingBtn superBtn" [ngClass]="{'bgSelectClass': superSelectedCondition}"
                    (click)="superSelectFunc()">
                    Super-admin
                </div>
            </div>
            <div *ngIf="restoSelectedCondition" class="containerResto">
                <div class="container-head">
                    <span class="noOfRestoList">{{noResto}} Restaurants</span>
                    <span class="resto-input">
                        <div style="padding: 2px">
                            <img src="../../../assets/images/Search.png" alt="" />
                            <input placeholder="Restaurant name" [(ngModel)]="searchText" (ngModelChange)="filter()"/>
                        </div>
                    </span>
                </div>
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 demo-table">
                    <!-- SlNo Column -->
                    <ng-container matColumnDef="SI-NO">
                        <th mat-header-cell *matHeaderCellDef class="table-head checking">
                            S.I<br />No.
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="table-element">
                            {{ i + 1 }}
                        </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="table-head checking">
                            Restaurants Name
                        </th>
                        <td mat-cell *matCellDef="let element" class="table-element h-70">
                            {{ element.name }}
                        </td>
                    </ng-container>

                    <!-- UserName Column -->
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef class="table-head checking">
                            Username
                        </th>
                        <td mat-cell *matCellDef="let element" class="table-element">
                            {{element.restaurant_unique_id}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef class="table-head checking">
                            Email
                        </th>
                        <td mat-cell *matCellDef="let element" class="table-element">
                            {{element.u_name}}
                        </td>
                    </ng-container>

                    <!-- Action Column -->

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="table-head action-th checking">
                            Action
                        </th>
                        <td mat-cell *matCellDef="let element" class="table-element action-element">
                            <img src="../../../assets/images/editIcon.png" alt="" class="edit-element" (click)="editRestPassword(element.restaurant_id)"/>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
                <mat-paginator
                #paginator
                [pageSizeOptions]="[12, 20, 25]"
                showFirstLastButtons
              ></mat-paginator>
            </div>
            <div *ngIf="superSelectedCondition">
                <super-acountsetting></super-acountsetting>
            </div>
        </div>
    </div>
</div>